import { render, staticRenderFns } from "./ManagePatientPage.vue?vue&type=template&id=4364803e&scoped=true&"
import script from "./ManagePatientPage.vue?vue&type=script&lang=js&"
export * from "./ManagePatientPage.vue?vue&type=script&lang=js&"
import style0 from "./ManagePatientPage.vue?vue&type=style&index=0&id=4364803e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364803e",
  null
  
)

export default component.exports